import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a6446f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "student-page" }
const _hoisted_2 = { class: "background" }
const _hoisted_3 = { class: "grid-wrapper noise" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "dashboard-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-5xl" }, "TRAINING DASHBOARD", -1))
const _hoisted_7 = { class: "flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Significant Weather ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Active Shooter ")
const _hoisted_10 = { class: "learning-progress" }
const _hoisted_11 = { class: "flex w-full progress-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Learning Progress", -1))
const _hoisted_13 = { class: "progress-wheels" }
const _hoisted_14 = { class: "flex flex-row flex-wrap justify-between content-evenly justify-items-start" }
const _hoisted_15 = { class: "profile-display" }
const _hoisted_16 = { class: "instructor-feedback" }
const _hoisted_17 = { class: "achievements" }

import { useGlobalStore } from '../store/globalStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, onMounted } from 'vue';
import ProfileDisplayComponent from '@/components/studentPage/ProfileDisplayComponent.vue';
import AchievementCarouselComponent from '../components/studentPage/AchievementCarouselComponent.vue';
import LoginButtonComponent from '@/components/LoginButtonComponent.vue';
import InstructorFeedbackComponent from '@/components/studentPage/InstructorFeedbackComponent.vue';
import ProgressSemiCircle from '@/components/ProgressSemiCircle.vue';
import Routes, { RouteNames } from '../router/Routes';
import { useRouter } from 'vue-router';
import Icon from '@/components/icon/Icon';
import ButtonComponent from '../components/ButtonComponent.vue';
import { ScenarioIds } from '../ecs/database';
import { useScenarioStore } from '../store/scenarioStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentPage',
  setup(__props) {

const router = useRouter();

const {
  firebaseUser,
  currentUser,
  currentCourse,
  currentClass,
  instructors,
  students,
  messages,
  achievements
} = storeToRefs(useGlobalStore());
const store = useGlobalStore();

const weatherProgress = computed(() => {
  const studentUser = students.value.find(
    (user) => user.uid === currentUser.value?.uid
  );
  if (studentUser) {
    return studentUser.score?.weather || 0;
  } else {
    return 0;
  }
});

const emergencyProgress = computed(() => {
  const studentUser = students.value.find(
    (user) => user.uid === currentUser.value?.uid
  );
  if (studentUser) {
    return studentUser.score?.emergency || 0;
  } else {
    return 0;
  }
});

const securityProgress = computed(() => {
  const studentUser = students.value.find(
    (user) => user.uid === currentUser.value?.uid
  );
  if (studentUser) {
    return studentUser.score?.security || 0;
  } else {
    return 0;
  }
});

const aircraftProgress = computed(() => {
  const studentUser = students.value.find(
    (user) => user.uid === currentUser.value?.uid
  );
  if (studentUser) {
    return studentUser.score?.aircraft || 0;
  } else {
    return 0;
  }
});

const weatherMaxPoints = 5000;
const emergencyMaxPoints = 5000;
const securityMaxPoints = 500;
const aircraftMaxPoints = 500;

onBeforeMount(async () => {
  if (!currentUser || !currentUser.value) {
    return;
  }
  await store.fetchCourse(
    currentUser.value.organizationId,
    currentUser.value.courseId
  );
  await store.fetchClass(
    currentUser.value.organizationId,
    currentUser.value.classId
  );
  await store.fetchInstructorUsers(currentUser.value.organizationId);
  await store.fetchStudentUsers(
    currentUser.value.organizationId,
    currentUser.value.courseId,
    currentUser.value.classId
  );
  await store.fetchSortedMessages(currentUser.value.classId);
});

onMounted(() => {
  store.pageViewEvent(RouteNames.STUDENT);
  if (store.currentUser) {
    store.fetchAchievements(store.currentUser.uid);
  }
});

const handleLaunchScenarioButtonClick = async (scenarioId: ScenarioIds) => {
  await useScenarioStore().getScenario(scenarioId);
  router.push({
    name: RouteNames.SCENARIO,
    params: { scenarioId }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LoginButtonComponent, {
            class: "mr-8 text-xs",
            isLoggedIn: _unref(currentUser) !== null,
            isEmailVerified: _unref(firebaseUser)?.emailVerified,
            currentUser: _unref(currentUser)
          }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ButtonComponent, {
              class: "flex justify-center flex-1 mx-2 whitespace-nowrap",
              "data-testid": "launch-scenario-one-button",
              "color-type": "tertiary",
              size: "medium",
              "right-icon-value": _unref(Icon).PLAY,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                handleLaunchScenarioButtonClick(_unref(ScenarioIds).SCENARIO_ONE_RANDOM)
              ))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["right-icon-value"]),
            _createVNode(ButtonComponent, {
              class: "flex justify-center flex-1 mx-2 whitespace-nowrap",
              "data-testid": "launch-scenario-two-button",
              "color-type": "tertiary",
              size: "medium",
              "right-icon-value": _unref(Icon).PLAY,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
                handleLaunchScenarioButtonClick(_unref(ScenarioIds).SCENARIO_TWO_RANDOM)
              ))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["right-icon-value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", {
              class: "ml-auto underline cursor-pointer place-self-end",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(_unref(Routes).TRAINING_HISTORY)))
            }, " View More ")
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(ProgressSemiCircle, {
              icon: _unref(Icon).AIRPLANE,
              progress: _unref(aircraftProgress),
              maxPoints: aircraftMaxPoints,
              label: "Aircraft Events"
            }, null, 8, ["icon", "progress"]),
            _createVNode(ProgressSemiCircle, {
              icon: _unref(Icon).SECURITY,
              progress: _unref(securityProgress),
              maxPoints: securityMaxPoints,
              label: "Security Events"
            }, null, 8, ["icon", "progress"]),
            _createVNode(ProgressSemiCircle, {
              icon: _unref(Icon).WEATHER,
              progress: _unref(weatherProgress),
              maxPoints: weatherMaxPoints,
              label: "Weather Events"
            }, null, 8, ["icon", "progress"]),
            _createVNode(ProgressSemiCircle, {
              icon: _unref(Icon).EMERGENCY,
              progress: _unref(emergencyProgress),
              maxPoints: emergencyMaxPoints,
              label: "Emergency Events"
            }, null, 8, ["icon", "progress"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(ProfileDisplayComponent, {
            currentUser: _unref(currentUser),
            "current-class": _unref(currentClass),
            "current-course": _unref(currentCourse),
            "current-instructors": _unref(instructors),
            "current-students": _unref(students),
            class: "h-full text-center"
          }, null, 8, ["currentUser", "current-class", "current-course", "current-instructors", "current-students"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(InstructorFeedbackComponent, { feedback: _unref(messages) }, null, 8, ["feedback"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(AchievementCarouselComponent, { items: _unref(achievements) }, null, 8, ["items"])
        ])
      ])
    ])
  ]))
}
}

})